import React, { useState } from "react";
import classes from './Payments.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import { Eye, Edit, Trash } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import Footer from "../../Components/Footer/Footer";
const Payments = () => {
    const location = useLocation();
    const data = [
        { ref: 'INV-001', supplier: 'Dangote Group', date: '2025-01-15', dueDate: '2025-02-24', amount: '₦2,000,000.00', status: 'Paid', type: 'Invoice' },
        { ref: 'INV-002', supplier: 'First Bank Nigeria', date: '2025-01-14', dueDate: '2025-01-31', amount: '₦1,500,000.00', status: 'Pending', type: 'Invoice' },
        { ref: 'INV-003', supplier: 'MTN Nigeria', date: '2025-01-13', dueDate: '2025-01-18', amount: '₦2,200,000.00', status: 'Overdue', type: 'Invoice' },
        { ref: 'QUO-001', supplier: 'Zenith Bank', date: '2025-01-12', dueDate: '2025-01-26', amount: '₦500,000.00', status: 'Draft', type: 'Quote' },
        { ref: 'INV-005', supplier: 'MTN Nigeria', date: '2025-01-11', dueDate: '2025-01-15', amount: '₦1,800,000.00', status: 'Overdue', type: 'Invoice' },
    ];
    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
 
            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Purchases</h2>
                    <h1 className={classes.Titles}>
                        Manage your purchase transactions, supplier invoices, and payments.
                    </h1>
                </header>

                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total sales</p>
                                <p className={classes.kdptg1}>₦8,400,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Outstanding</p>
                                <p className={classes.kdptg2}>₦4,950,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Pending payments</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Overdue</p>
                                <p className={classes.kdptg3}>₦3,200,000.00</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Past due dates</p>
                                </div>
                            </div>
                        </div>
                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>This month</p>
                                <p className={classes.kdptg4}>15</p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Total invoices</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                            <input type="text" className={classes.searchBar} placeholder="Search sales" />
                        </div>
                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All Status</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <input type="text" className={classes.searchBars} placeholder="Filter..." />
                            <img src={filter} alt="Filter" className={classes.inputIcon} />
                        </div>
                    </div>
                    <button className={classes.btnss}> + New purchases</button>
                </div>

                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>Reference #</th>
                                <th>Supplier</th>
                                <th>Date</th>
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Type</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index} className={classes.tableRow}>
                                    <td className={classes.tableCell}>{row.ref}</td>
                                    <td className={classes.tableCell}>{row.supplier}</td>
                                    <td className={classes.tableCell}>{row.date}</td>
                                    <td className={classes.tableCell}>{row.dueDate}</td>
                                    <td className={classes.tableCell}>{row.amount}</td>
                                    <td className={classes.tableCell}>
                                        <span className={`${classes.statusButton} ${classes['status' + row.status]}`}>
                                            {row.status}
                                        </span>
                                    </td>
                                    <td className={classes.tableCell}>{row.type}</td>
                                    <td className={classes.tableCell}>
                                        <div className={classes.actionIcons}>
                                            <Eye size={16} />
                                            <Edit size={16} style={{ margin: '0 8px' }} />
                                            <Trash size={16} />
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <table className={classes.footerTable}>
                    <tfoot>
                        <tr>
                            <td>First</td>
                            <td className={`${classes.page} ${classes.activePage}`}>1</td>
                            <td className={classes.page}>2</td>
                            <td>Last</td>
                        </tr>
                    </tfoot>
                </table>

                <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>
            </div>
            <Footer />
        </div>
    );
};

export default Payments;